import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'public',
  components: {},
})
export default class Public extends Vue {
  checkHasHomePageOrAllowAccessPublicWebpage() {
    if (
      this.selectedTenant &&
      this.centerSettings &&
      this.$route.name !== 'public-payment-invoice' &&
      this.$route.name !== 'public-entry-barcode' &&
      this.$route.name !== 'calendar-public' &&
      this.$route.name !== 'weekly-calendar'
    ) {
      if (!this.hasHomepage || !this.allowAccessPublicWebpage || !this.isCmsModuleActivated) {
        this.$router.push({
          name: 'auth-tenant-login',
        });
      }
    }
  }

  checkHasHomePageOrAllowAccessPublicWebpageForClub() {
    if (
      this.selectedTenant &&
      this.centerSettings &&
      this.$route.name !== 'public-payment-invoice' &&
      this.$route.name !== 'public-entry-barcode' &&
      this.$route.name !== 'calendar-public' &&
      this.$route.name !== 'weekly-calendar'
    ) {
      if (!this.allowAccessNewContactForm) {
        this.$router.push({
          name: 'public',
        });
      }
      if (
        this.$route.name === 'public' &&
        (!this.hasHomepage || !this.allowAccessPublicWebpage || !this.isCmsModuleActivated)
      ) {
        this.$router.push({
          name: 'auth-tenant-login',
        });
      }
    }
  }

  @Watch('centerSettings', { immediate: true, deep: true })
  onCenterSettingsChange() {
    if (this.centerSettings) {
      if (this.centerType === 'club') {
        this.checkHasHomePageOrAllowAccessPublicWebpageForClub();
      } else {
        this.checkHasHomePageOrAllowAccessPublicWebpage();
      }
    }
  }
  get centerSettings() {
    return this.$store.getters['centerSettings/centerSettings'];
  }
  get isCmsModuleActivated() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.CMS_MODULE_NAME);
  }
  get hasHomepage() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].has_homepage;
    }
    return null;
  }
  get allowAccessPublicWebpage() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].allow_access_public_website;
    }
    return null;
  }
  get centerType() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].center_type;
    }
    return null;
  }
  get allowAccessNewContactForm() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].allow_access_new_contact_form;
    }
    return null;
  }
  @Watch('selectedTenant', { immediate: true, deep: true })
  onSelectedTenantChange() {
    if (this.centerSettings) {
      if (this.centerType === 'club') {
        this.checkHasHomePageOrAllowAccessPublicWebpageForClub();
      } else {
        this.checkHasHomePageOrAllowAccessPublicWebpage();
      }
    }
  }
  get selectedTenant() {
    if (this.$store.getters['tenant/selectedTenant']) {
      return this.$store.getters['tenant/selectedTenant'];
    }
    return null;
  }
}
